import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import {
    MAT_LUXON_DATE_ADAPTER_OPTIONS,
    provideLuxonDateAdapter,
} from "@angular/material-luxon-adapter";

export function provideLuxonDateAdapterConfig(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideLuxonDateAdapter({
            parse: {
                dateInput: "dd/MM/yyyy",
            },
            display: {
                dateInput: "dd/MM/yyyy",
                monthYearLabel: "MMMM yyyy",
                dateA11yLabel: "LL",
                monthYearA11yLabel: "MMMM yyyy",
            },
        }),
        { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true, strict: true } },
    ]);
}
